<template>
<div>
    <gform :props="props" :formname="formname" :rowdata="rowdata" :formmodel="'theform'" :thetext="'U'"></gform>
</div>
</template>

<script>
import gform from "./gform"
export default {
    components:{gform},
    props: ["props", "rowdata","formname"],
    data(){
        return {
 
        }
    }
    
}
</script>


// WEBPACK FOOTER //
// src/components/utility/commonfields/form/theform.vue